var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCollab = function SvgCollab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 124 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.318 118 62 97.843 23.68 118 31 75.305 0 45.072l42.84-6.228L62 0l19.16 38.844L124 45.072 93 75.306 100.318 118ZM62 88.466l27.302 14.361-5.214-30.418 22.088-21.543-30.516-4.437L62 18.754 48.35 46.429l-30.515 4.437 22.088 21.543-5.224 30.418L62 88.467Z",
    fill: "currentColor"
  })));
};

export default SvgCollab;